import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'
import { useTranslate } from '@repo/unicity'

export interface ErrorMessagesProps {
    list: string[]
    showUuid?: boolean
    sx?: SxProps<Theme>
}

export const ErrorMessages = ({ list, showUuid = true, sx }: ErrorMessagesProps) => {
    const { translate } = useTranslate()

    if (!list.length) return null

    const uuid = new URLSearchParams(document.location.search).get('uuid')
    const items = showUuid && uuid ? [...list, `UUID: ${uuid}`] : list
    const containerSx: SxProps<Theme> = [
        {
            bgcolor: '#FFE7EB',
            pt: '15px',
            pb: '15px',
            justifyContent: 'center',
            borderRadius: '12px',
            mt: '4px'
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
    ]

    return (
        <Stack sx={containerSx} data-testid="error-messages-stack">
            {items.map((item, i) => {
                const isLast = items.length - 1 === i
                return (
                    <Box key={i} textAlign="center" px="30px" data-testid="error-messages-box-typography-1">
                        <Box
                            sx={{
                                borderBottom: isLast ? 0 : '1px dashed red',
                                pb: isLast ? 0 : '15px',
                                mb: isLast ? 0 : '15px'
                            }}
                            data-testid="error-messages-box-typography-2">
                            <Typography
                                variant="body2"
                                component="div"
                                sx={{ fontSize: 14, fontWeight: 400, color: 'rgb(254, 93, 124)' }}
                                dangerouslySetInnerHTML={{ __html: translate(item) }}
                                data-testid="error-messages-typography"
                            />
                        </Box>
                    </Box>
                )
            })}
        </Stack>
    )
}
